module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./QuickBuySwiperView.js"));
	}, "QuickBuySwiperView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=QuickBuySwiperView!./src/pages/Shop/Member/TradeManage/QuickBuySwiper/QuickBuySwiperView.js
// module id = 1047
// module chunks = 431